module.exports = "https://web-assets-production.autolist.com/_next/static/images/suv-25aca4dbb19046d96fb2dca30461b0dd.jpg";